//FILTRE EQUIPE
// TODO: Refactor this file please...
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains('page-nos-equipes')) {
    if (!!window.location.hash && window.location.hash !== '#filtre') {
      const $etablissementLink = jQuery('.etablissement-list_item[data-etablissement-slug="'+window.location.hash.replace('#', '')+'"]');
      if ($etablissementLink.length) {
        jQuery(".etablissement-list_item").removeClass("active");
        $etablissementLink.addClass("active");
        ajaxEquipes($etablissementLink.data("etablissement"), $etablissementLink.data("type"));
      }
    } else {
      if (jQuery("#equipes")) {
        ajaxEquipes();
      }
    }
  
    jQuery(".etablissement-list_item").on("click", function () {
      jQuery(".etablissement-list_item").removeClass("active");
      jQuery(this).addClass("active");
      ajaxEquipes(jQuery(this).data("etablissement"), jQuery(this).data("type"));
    });
  
    function ajaxEquipes(etablissement = "", type = "collaborateur") {
      jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        dataType: "html",
        data: {
          action: "filter_equipe",
          etablissement: etablissement,
          type: type,
        },
        success: function (res) {
          if (res) {
            jQuery("#equipe_isotope").html(res);
            loadmore_equipes_params.current_page = 1;
            jQuery(".loadmore_equipes")
              .text("Voir le reste de l'équipe")
              .css("pointer-events", "unset");
    
            var max_num_pages = document.getElementById("max_num_pages");
    
            if (max_num_pages !== null) {
              if (loadmore_equipes_params.current_page == max_num_pages.innerText) {
                jQuery(".loadmore_equipes")
                  .text("Toute l'équipe est affichée")
                  .css("pointer-events", "none");
              } else {
                // jQuery('.loadmore_equipes').text("Toute l'équipe est affichée")
                //     .css('pointer-events', 'none');
              }
            }
          }
        },
      });
    }
    
    let isLoadingMore = false;
  
    function handleInfiniteScrollTeam () {
      let options = {
          threshold: 0.5
      };
  
      let observer = new IntersectionObserver(
          function (entries, observer) {
              handleIntersect(entries, observer); 
          }, 
          options
      );
  
      const $loadMoreBtn = document.querySelector('.loadmore_equipes');
      if ($loadMoreBtn) {
          observer.observe($loadMoreBtn);
      }
      
      const handleIntersect = function (entries, observer) {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isLoadingMore) {
              loadMoreTeam();
            }
          });
      };
    }
    
    function loadMoreTeam () {
      var button = jQuery('.loadmore_equipes');
      var activeEtablissement = jQuery('.etablissement-list_item.active');
      isLoadingMore = true;
  
      jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        dataType: "html",
        data: {
          action: "loadmore_equipes",
          etablissement: activeEtablissement.data("etablissement"),
          type: activeEtablissement.data("type"),
          page: loadmore_equipes_params.current_page,
        },
        beforeSend: function (xhr) {
          button.text("Chargement..."); // change the button text, you can also add a preloader image
        },
        success: function (res) {
          if (res) {
            loadmore_equipes_params.current_page++;
    
            jQuery("#equipe_isotope").append(res);
            button.text("Voir le reste de l'équipe").css("pointer-events", "unset");
    
            var max_num_pages = document.getElementById("max_num_pages");
    
            if (loadmore_equipes_params.current_page == max_num_pages.innerText) {
              button
                .text("Toute l'équipe est affichée")
                .css("pointer-events", "none");
            }
          } else {
            button
              .text("Toute l'équipe est affichée")
              .css("pointer-events", "none");
          }
        },
        complete: () => {
          isLoadingMore = false;
        }
      });
    }
      
    //LOADMORE EQUIPE
    jQuery(".loadmore_equipes").on("click", function () {
      if (!isLoadingMore) {
        loadMoreTeam();
      }
    });
  
    handleInfiniteScrollTeam();
  }
});

